import React from 'react'
import { useHistory } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { useInitialQueryStringParameters } from '../../lib/query-string'
import { ConsumerLoginLink, PGAMemberLoginLink } from '../../components/login-actions'
import SignUpForm from '../../components/sign-up-form'

const AnonymousView = () => {
  const history = useHistory()
  const { mobileAppSignUp } = useInitialQueryStringParameters()

  const onSignupFormSuccess = (formValues) => {
    history.push(`/confirm-account?username=${encodeURIComponent(formValues.email)}`)
  }

  return (
    <>
      {!mobileAppSignUp && (
        <Box mb={1}>
          <Typography variant="body1">
            Already have an account?&nbsp;
            <ConsumerLoginLink />
          </Typography>
        </Box>
      )}
      <Box mb={4}>
        <SignUpForm onSuccess={onSignupFormSuccess} />
      </Box>
      {!mobileAppSignUp && (
        <Box mb={4} display="flex" flexDirection="column" alignItems="center">
          <PGAMemberLoginLink />
        </Box>
      )}
    </>
  )
}

export default AnonymousView
